import { computed, Signal } from '@angular/core';
import { UrlService } from '../../../services/url/url.service';


export function getLabels(urlService: UrlService) {

	const en = urlService.isEnglish;
	return {
		messages: <{ [index: string]: Signal<string | undefined> }>{
			information: computed(() => en() ? 'Information' : 'Información'),
			alert: computed(() => en() ? 'Alert' : 'Alerta'),
			error: computed(() => en() ? 'Error' : 'Error'),
			success: computed(() => en() ? 'Success' : 'Éxito'),
			question: computed(() => en() ? 'Question' : 'Pregunta'),
			consider: computed(() => en() ? 'Consider' : 'Considerar'),
		}
	}
}
